import FormInput from "@babackapp/react-hook-forms-components/form-input";
import FormInputContainer from "@babackapp/react-hook-forms-components/form-input-container";
import { Button } from "@babackapp/ui/components/button";
import { FormField } from "@babackapp/ui/components/form";
import { PlusIcon, TrashIcon } from "@radix-ui/react-icons";
import { useFieldArray, useFormContext } from "react-hook-form";
import { PortalExchangeFormValues } from "./portal-exchange-card";
import useTranslation from "@babackapp/translations/use-translation";

type PortalExchangeCollectionFormProps = {
  disabled?: boolean | string;
};

export default function PortalExchangeCollectionForm({
  disabled,
}: PortalExchangeCollectionFormProps = {}) {
  const t = useTranslation();

  const { control } = useFormContext<PortalExchangeFormValues>();

  const collections = useFieldArray({
    control,
    name: "collections",
  });

  const onAddCollection = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    collections.append({
      collection: "",
      optionTitle: "",
    });
  };

  return (
    <FormInputContainer
      label={t("settings.exchange.fields.collections.title")}
      description={t("settings.exchange.fields.collections.description")}
      disabled={disabled}
    >
      <div className="flex flex-col gap-2">
        {collections.fields.map((field, index) => (
          <div className="flex gap-2 items-end justify-end" key={index}>
            <FormField
              control={control}
              name={`collections.${index}.collection`}
              render={({ field }) => (
                <FormInput
                  selectAllOnFocus
                  label={t(
                    "settings.exchange.fields.collections.fields.collection.title",
                  )}
                  {...field}
                />
              )}
            />
            <FormField
              control={control}
              name={`collections.${index}.optionTitle`}
              render={({ field }) => (
                <FormInput
                  selectAllOnFocus
                  label={t(
                    "settings.exchange.fields.collections.fields.optionTitle.title",
                  )}
                  {...field}
                />
              )}
            />
            <div>
              <Button
                role="button"
                variant="outline"
                size="icon"
                onClick={() => collections.remove(index)}
              >
                <TrashIcon className="size-4" />
              </Button>
            </div>
          </div>
        ))}
        <div className="flex justify-start">
          <Button
            role="button"
            className="flex gap-2 justify-self-start"
            size="sm"
            variant="outline"
            onClick={onAddCollection}
          >
            {t("settings.config.collections.addCollection")}{" "}
            <PlusIcon className="size-4" />
          </Button>
        </div>
      </div>
    </FormInputContainer>
  );
}
